/** @jsx jsx */

import { css, jsx } from "@emotion/core"
import { Icon } from "@cd2/components"
import { icons } from "./icons"
import { adminCompanyTagColors } from "./adminCompanyTagStyles"

export function AdminCompanyTagPill({
  name,
  interactive,
  onClick,
}: {
  name: string
  interactive?: boolean
  onClick?(): void
}) {
  return (
    <span
      css={css`
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: ${adminCompanyTagColors.pillBackground};
        border-radius: 999px;
        padding: 3px 8px;
        font-size: 12px;
        width: max-content;
        ${interactive &&
        css`
          cursor: pointer;
          :hover {
            background: ${adminCompanyTagColors.pillHoverBackground};
          }
        `}
      `}
      title={interactive ? "Remove" : undefined}
      onClick={onClick}
    >
      <Icon icon={icons.companyTags} prefix="solid" color={adminCompanyTagColors.iconColor} />
      {name}
      {interactive ? " ×" : null}
    </span>
  )
}

export function AdminCompanyTagBadge() {
  return (
    <span
      css={css`
        font-size: 11px;
        padding: 2px 6px;
        border-radius: 999px;
        background: ${adminCompanyTagColors.badgeBackground};
        display: inline-flex;
        align-items: center;
      `}
    >
      <Icon icon={icons.companyTags} prefix="solid" color={adminCompanyTagColors.iconColor} />
    </span>
  )
}
